module.exports = "/_next/static/images/5d19860fe304d970c1663cb9d4135784-Nubank_HickDuarte_55193_lg.jpg";